<template>
  <v-container id="extended-tables" fluid tag="section">
    <base-v-component heading="" link="componetns/simple-tables" />

    <base-material-card color="success" icon="mdi-clipboard-text" inline title="Sensores" class="px-5 py-3 mb-5">
      <v-row>
        <v-col cols="12" md="4">
          <v-select v-model="urbanizacion" outlined :items="urbanizaciones" label="Urbanizaciones" item-text="name"
            item-value="id" persistent-hint return-object single-line v-on:change="listarEdificios()"></v-select>
        </v-col>
        <v-col cols="12" md="4">
          <v-select v-model="edificio" outlined :items="edificios" label="Edificios" item-text="name" item-value="id"
            persistent-hint return-object single-line></v-select>
        </v-col>
        <v-col cols="12" md="4">
          <v-select v-model="grupo" outlined :items="grupos" label="Grupos de sensores" item-text="name" item-value="id"
            persistent-hint return-object single-line v-on:change="listar(),listarPropiedades()"></v-select>
        </v-col>
      </v-row>
      
      <v-row>
        <v-col cols="12" md="12" class="mt-10">
          <v-data-table :headers="headers" :items="sensores" sort-by="calories" class="elevation-1" :search="search">
            
            <template v-slot:top>
              <v-toolbar flat>
                <v-toolbar-title>Sensores</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-text-field v-model="search" append-icon="mdi-magnify" label="Buscar" single-line
                  hide-details></v-text-field>
                <v-spacer></v-spacer>
                <v-dialog v-model="dialog" max-width="500px">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn color="primary" dark class="mb-2" v-bind="attrs" v-on="on" @click="nuevo()">
                      Nuevo Sensor
                    </v-btn>
                  </template>
                  <v-card>
                    <v-toolbar dark color="primary">
                      <v-btn icon dark @click="close">
                        <v-icon>mdi-close</v-icon>
                      </v-btn>
                      <v-toolbar-title>{{ formTitle }} </v-toolbar-title>
                      <v-spacer></v-spacer>
                    </v-toolbar>

                    <v-card-text>
                      <v-form ref="form" v-model="validForm">
                        <v-container>
                          <v-divider></v-divider>
                          <v-row>
                            <v-col cols="12" sm="12" md="12">
                              <v-select v-model="property" outlined :items="properties" label="Propiedades"
                                item-text="property" item-value="id" persistent-hint return-object single-line required :rules="requiredRule"></v-select>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col cols="12" sm="12" md="12">
                              <v-select v-model="grupoPop" outlined :items="grupos" label="Grupos de sensores"
                                item-text="name" item-value="id" persistent-hint return-object single-line required :rules="requiredRule"></v-select>
                            </v-col>
                          </v-row>
                          <!--
                          <v-row>
                            <v-col cols="12" sm="6" md="6">
                              <v-text-field v-model="nombrePop" label="Nombre" :rules="CamposRules"></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="6">
                              <v-text-field v-model="emailPop" label="Email" :rules="EmailRules"></v-text-field>
                            </v-col>
                          </v-row>
                          -->
                          <v-row>
                            <v-col cols="12" sm="6" md="6">
                              <v-text-field v-model="medidaPop" label="Medida" required :rules="requiredRule"></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="6">
                              <v-text-field v-model="unidadPop" label="Unidad" required :rules="requiredRule"></v-text-field>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col cols="12" sm="6" md="6">
                              <v-text-field v-model="medida1Pop" label="Medida1"></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="6">
                              <v-text-field v-model="unidad1Pop" label="Unidad1"></v-text-field>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col cols="12" sm="6" md="6">
                              <v-text-field v-model="medida2Pop" label="Medida2"></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="6">
                              <v-text-field v-model="unidad2Pop" label="Unidad2"></v-text-field>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col cols="12" sm="6" md="6">
                              <v-text-field v-model="longitudPop" label="Longitud"
                                required :rules="requiredRule" type="number"></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="6">
                              <v-text-field v-model="latitudPop" label="Latitud" required :rules="requiredRule" type="number"></v-text-field>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col cols="12" sm="6" md="6">
                              <v-switch v-model="activo" inset color="red" label="Activo">
                              </v-switch>
                            </v-col>
                          </v-row>
                          <v-divider></v-divider>
                        </v-container>
                      </v-form>
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="secondary" @click="close"> Cerrar </v-btn>

                      <v-btn :disabled="!valid" color="success" class="mr-4" @click="guardar">Guardar</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
                <v-dialog v-model="dialogDelete" max-width="500px">
                  <v-card>
                    <v-card-title class="text-h5">Esta seguro de eliminar datos?</v-card-title>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="blue darken-1" text @click="closeDelete">Cancel</v-btn>
                      <v-btn color="blue darken-1" text @click="deleteItemConfirm">OK</v-btn>
                      <v-spacer></v-spacer>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-toolbar>
            </template>
            <template v-slot:item.actions="{ item }">
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn icon v-on="on" large @click="editar(item)">
                    <v-icon dense color="secondary">mdi-pencil</v-icon>
                  </v-btn>
                </template>
                <span>Editar datos</span>
              </v-tooltip>

              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn icon v-on="on" large @click="deleteItem(item)">
                    <v-icon dense color="primary">mdi-delete</v-icon>
                  </v-btn>
                </template>
                <span>Eliminar</span>
              </v-tooltip>
            </template>
        
            <template v-slot:no-data>
              <v-btn color="primary" @click="initialize"> Recargar </v-btn>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </base-material-card>

    <v-snackbar v-model="snackbar" :timeout="timeout">
      {{ text }}

      <template v-slot:action="{ attrs }">
        <v-btn color="blue" text v-bind="attrs" @click="snackbar = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
import axios from "axios";
export default {
  name: "DashboardExtendedTables",

  data: () => ({
    urbanizaciones: [],
    urbanizacion: [],
    edificios: [],
    edificio: [],
    grupos: [],
    grupo: [],
    dialog: false,
    dialogDelete: false,
    headers: [
      { text: "Id", value: "id" },
      { text: "Nombre", value: "name" },
     
     // { text: "Activo", value: "active" },
      { text: "Nombre de medida", value: "name_of_measure" },
      { text: "Unidad de medida", value: "unit_of_measurement" },
      { text: "Nombre de medida 1", value: "name_of_measure1" },
      { text: "Unidad de medida 1", value: "unit_of_measurement1" },
      //{ text: "Nombre de medida 2", value: "name_of_measure2" },
      //{ text: "Unidad de medida 2", value: "unit_of_measurement2" },
      { text: "Latitud", value: "latitude" },
      { text: "Longitud", value: "longitude" },
      { text: "Acciones", value: "actions", sortable: false },
    ],
    sensores: [],
    editedIndex: -1,
    codigo: "",
    diagnostico: "",

    search: "",
    snackbar: false,
    text: "",
    timeout: 6000,

    // pop up
    numericRule: value =>
      /^-?\d*\.?\d*$/.test(value) || "Debe ser un número válido",
    valid: true,
    EmailRules: [
      value => !!value || "Requerido.",
      value => (value || "").length <= 50 || "Max 50 caracteres",
      value => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(value) || "e-mail incorrecto.";
      }
    ],
    CamposRules: [
      value => !!value || "Requerido.",
      value => (value || "").length <= 50 || "Max 50 caracteres"
    ],
    grupoPop: [],
    //nombrePop: "",
    //emailPop: "",
    medidaPop: "Metros cubicos",
    unidadPop: "m3",
    medida1Pop: "",
    unidad1Pop: "",
    medida2Pop: "",
    unidad2Pop: "",
    longitudPop: "",
    latitudPop: "",
    activo: true,
    properties:[],
    property: [],
    id: "",
    validForm: false,
    requiredRule: [(v) => !!v || 'Este campo es obligatorio'],
  }),
  

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "Nuevo sensor" : "Editar sensor";
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
    loader() {
      const l = this.loader;
      this[l] = !this[l];

      setTimeout(() => (this[l] = false), 6000);

      this.loader = null;
    },
  },

  created() {
    this.initialize();
  },

  methods: {
    initialize() {
      this.listarGrupos();
      this.listarUrbanizaciones();
      
      //this.listar();
    },
    nuevo(){
      let me = this;
      me.editedIndex = -1;
       me.$refs.form.reset()
    },
    listarUrbanizaciones() {
      let me = this;
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .get("api/Communities", configuracion)
        .then(function (response) {
          me.urbanizaciones = response.data;
          console.log(response.data);
        })
        .catch((err) => {
          if (err.response.status == 401) {
            this.$store.dispatch("salir");
          }
        });
    },
    listarEdificios() {
      let me = this;
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      me.edificios = [];
      axios
        .get("api/Buildings/BuildingByCommunity/" + me.urbanizacion.id, configuracion)
        .then(function (response) {
          me.edificios = response.data;
          console.log(response.data);
        })
        .catch((err) => {
          if (err.response.status == 401) {
            this.$store.dispatch("salir");
          }
        });
    },
    listarPropiedades() {
      let me = this;
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      me.properties = [];
      axios
        .get("/api/Sensors/SensorByBuilding/" + me.grupoPop.id +"/" +me.edificio.id, configuracion)
        .then(function (response) {
          me.properties = response.data;
          console.log(response.data);
        })
        .catch((err) => {
          if (err.response.status == 401) {
            this.$store.dispatch("salir");
          }
        });
    },
    listarGrupos() {
      let me = this;
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .get("api/Groups", configuracion)
        .then(function (response) {
          me.grupos = response.data;
          console.log(response.data);
        })
        .catch((err) => {
          if (err.response.status == 401) {
            this.$store.dispatch("salir");
          }
        });
    },
    listar() {
      let me = this;
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .get("api/Sensors/SensorByGroup/" + me.grupo.id + "/" + me.edificio.id, configuracion)
        .then(function (response) {
          me.sensores = response.data;
          //change to string bool value
        })
        .catch((err) => {
          if (err.response.status == 401) {
            this.$store.dispatch("salir");
          }
        });
    },
    guardar() {
      let me = this;
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      if (this.$refs.form.validate()) {
      if (this.editedIndex > -1) {
        //edit
        console.log("Actualizar " + me.property.id);
        axios
          .post(
            "/api/Sensors/UpdateSensor",
            {
              id: me.id,
              GroupUq: me.grupoPop.id,
              PropertyUq: me.property,
              name: "",
              email: "",
              Latitude: me.latitudPop,
              Longitude: me.longitudPop,
              Active: me.activo,
              nameOfMeasure: me.medidaPop,
              unitOfMeasurement: me.unidadPop,
              nameOfMeasure1: me.medida1Pop,
              unitOfMeasurement1: me.unidad1Pop,
              nameOfMeasure2: me.medida2Pop,
              unitOfMeasurement2: me.unidad2Pop,
              
            },
            configuracion
          )
          .then(function (response) {
            me.listar();
            me.$refs.form.reset();
            console.log(response);
          })
          .catch((err) => {
            if (err.response.status == 401) {
              this.$store.dispatch("salir");
            }
          });
      } else {
        console.log("crear medicamento");
        axios
          .post(
            "/api/Sensors/InsertSensor",
            {
              GroupUq: me.grupoPop.id,
              PropertyUq: me.property.id,
              name: "",
              email: "",
              Latitude: me.latitudPop,
              Longitude: me.longitudPop,
              Active: me.activo,
              nameOfMeasure: me.medidaPop,
              unitOfMeasurement: me.unidadPop,
              nameOfMeasure1: me.medida1Pop,
              unitOfMeasurement1: me.unidad1Pop,
              nameOfMeasure2: me.medida2Pop,
              unitOfMeasurement2: me.unidad2Pop,
              active: true
            },
            configuracion
          )
          .then(function (response) {
            me.listar();
            me.listarPropiedades();
            me.$refs.form.reset();
            console.log(response);
          })
          .catch((err) => {
            if (err.response.status == 400) {
                me.snackbar = true;
                me.text = err.response.data.errors;
              }
            if (err.response.status == 401) {
              this.$store.dispatch("salir");
            }
          });
      }
      this.close();
    }
    },
    editar(item) {
      console.log("editar");
      console.log(item);
      let me = this;
      me.id=item.id;
      me.grupoPop = item.group_uq;
      //me.edificio = item.building;
      me.property = item.property_uq;
      console.log("proery uq de item");
      console.log(item.property_uq)
      console.log("proery uq de me");
      console.log(me.property );
      me.medidaPop = item.name_of_measure;
      me.unidadPop = item.unit_of_measurement;  
      me.medida1Pop = item.name_of_measure1;
      me.unidad1Pop = item.unit_of_measurement1;

      me.medida2Pop = item.name_of_measure2;
      me.unidad2Pop = item.unit_of_measurement2;
      me.latitudPop = item.latitude;
      me.longitudPop = item.longitude;
      me.activo = item.active;
      me.editedIndex = 1;
      this.dialog = true;
    },

    deleteItem(item) {
      let me = this;
      me.id = item.id;
      console.log(item);
      me.dialogDelete = true;
    },

    deleteItemConfirm() {
      let me = this;
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .get("api/Sensors/Delete/" + me.id, configuracion)
        .then(function (response) {
          me.dialogDelete = false;
          if (response.data[0]["error"]) {
            me.snackbar = true;
            me.text = response.data[0]["messagge"];
          }
          me.listar();
        })
        .catch((err) => {
          if (err.response.status == 401) {
            this.$store.dispatch("salir");
          }
        }
        );
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
  },
};
</script>